import styled from 'styled-components';
import { EmptyButton, getTheme, parseProp, parseTheme, size } from 'mol-ui';

export const Body = styled.div`
    ${ parseTheme('background-color', 'primaryLighterColor') }
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow-y: auto;
    padding: 0px;
    width: 100%;
`;

export const DownloadCancel = styled.div`
    color: ${ getTheme('primaryColor') };
    cursor: pointer;
    display: inline-block;
    font-size: 14px;
    text-decoration: none;
`;

export const DownloadContainer = styled.div`
    border-bottom: 1px solid ${ getTheme('disabledColor') };
    padding: 10px 0px 10px 20px;
    .download-button {
        color: ${ getTheme('primaryColor') };
        display: inline-block;
        font-size: 14px;
        text-decoration: none;
    }
`;

export const DownloadPrepare = styled(EmptyButton)`
    color: ${ getTheme('primaryColor') };
    display: inline-block;
    font-size: 14px;
`;

export const Filter = styled.div`
    align-items: center;
    color: ${ getTheme('textColor') };
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    min-width: 200px;
    ${ size.xs(`
        justify-content: center;
    `) }
`;

export const FilterBox = styled.div`
    align-items: center;
    display: flex;
    ${ parseProp('display') }
    flex: 1;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: flex-end;
    padding: 0px 5px;
    position: relative;
    width: fit-content;

    ${ size.xs(`
        align-items: flex-end;
        flex-direction: column;
        padding: 0px 10px;
        width: 100%;
    `) }
`;

export const Header = styled.div`
    align-items: center;
    ${ parseTheme('background-color', 'primaryLighterColor') }
    border-bottom: 1px solid ${ getTheme('disabledColor') };
    display: flex;
    gap: 10px;
    padding: 10px 5px;
    position: relative;
    width: 100%;
    ${ size.xs(`
        flex-direction: column;
        height: auto;
        padding: 15px 0px 5px 0px;
        transition: all 0.3s ease;
    `) }
`;

export const IconContainer = styled.div`
    align-items: center;
    cursor: pointer;
    display: flex;
`;

export const Message = styled.div`
    color: ${ getTheme('textColor') };
    font-size: 14px;
    margin: 15px 0px 0px 10px;
`;

export const SearchBox = styled.div `
    align-items: center;
    display: flex;
    margin-right: 5px;
`;

export const Title = styled.div`

`;
